import { Colors, Fonts } from '../../../../../shared/theme';
import colors from '../../../../../shared/theme/colors';
import styleButton from '../../../../../shared/components/rbh-button/styles';
import metrics from '../../../../../shared/theme/metrics';

export default {
  addCategoryText: {
    paddingLeft: 20,
    color: '#4B2885',
    cursor: 'pointer',
    fontFamily: 'Kanit-Regular'
  },
  addCategoryTextInner: {
    textDecoration: 'underline'
  },
  option_promotion: {
    color: '#D3329A',
    fontFamily: Fonts.type.KanitMedium,
  },
  remark: {
    marginTop: 8,
    whiteSpace: 'pre-line',
    color: colors.font.primary.fakeBlack
  },
  redRemark: {
    color: '#FF0000',
    whiteSpace: 'pre-line',
    textAlign: 'center',
    fontFamily: 'Kanit-Light',
    fontSize: 14
  },
  tagPickerRemark: {
    color: colors.font.messaging.lightRed,
    whiteSpace: 'pre-line',
    fontFamily: 'Kanit-Light',
    fontSize: 14
  },
  selectDetailProduct: {
    ...styleButton.buttonModalCancelGradient,
    width: metrics.base * 15.3
  },
  editDetailProduct: {
    ...styleButton.buttonModalCancelGradient,
    width: metrics.base * 15.9,
  },
  detailProductBtnBox: {
    marginLeft: metrics.base * 36.6,
    marginBottom: metrics.baseMargin
  },
  calendarInput: {
    width: '180px',
    borderRadius: '4px',
    height: '40px'
  },
  selectTime: {
    width: '112px',
    marginLeft: '8px'
  },
  dateTimeInput: {
    display: 'inline-block',
    marginBottom: 0
  },
  timeOption: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.black
  },
  timeOptionDisabled: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.grey
  }
};

export const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 16 },
};

export const buttonLayout = {
  wrapperCol: { offset: 10, span: 16 },
};